import { cmsHttp } from 'shared/api/mfe-axios';
import { buildSpringPageParams } from 'shared/api/list-query-params';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
export const ACTION_TYPES = {
    FETCH_CARD_FREEZE_REQUESTS_LIST: 'cardFreezeRequest/FETCH_CARD_FREEZE_REQUESTS_LIST',
    FETCH_CARD_FREEZE_REQUESTS_BY_CARD_ID: 'cardFreezeRequest/FETCH_CARD_FREEZE_REQUESTS_BY_CARD_ID',
    CREATE_CARD_FREEZE_REQUEST: 'cardFreezeRequest/CREATE_CARD_FREEZE_REQUEST',
    UPDATE_CARD_FREEZE_REQUEST: 'cardFreezeRequest/UPDATE_CARD_FREEZE_REQUEST',
    APPROVE_CARD_FREEZE_REQUEST: 'cardFreezeRequest/APPROVE_CARD_FREEZE_REQUEST',
    RESET: 'cardFreezeRequest/RESET',
};
const listApiUrl = 'api/card-freeze-requests';
const apiUrl = 'api/card-freeze-requests';
const initialState = {
    loading: false,
    errorMessage: null,
    entities: [],
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_LIST):
        case REQUEST(ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_BY_CARD_ID):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_FREEZE_REQUEST):
        case REQUEST(ACTION_TYPES.UPDATE_CARD_FREEZE_REQUEST):
        case REQUEST(ACTION_TYPES.APPROVE_CARD_FREEZE_REQUEST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_LIST):
        case FAILURE(ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_BY_CARD_ID):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.CREATE_CARD_FREEZE_REQUEST):
        case FAILURE(ACTION_TYPES.UPDATE_CARD_FREEZE_REQUEST):
        case FAILURE(ACTION_TYPES.APPROVE_CARD_FREEZE_REQUEST):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_LIST):
        case SUCCESS(ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_BY_CARD_ID): {
            const body = action.payload.data;
            const list = Array.isArray(body) ? body : body?.content ?? [];
            const countHeader = action.payload.headers?.['x-total-count'];
            const total = countHeader != null && countHeader !== '' ? parseInt(countHeader, 10) : list.length;
            return {
                ...state,
                loading: false,
                entities: list,
                totalItems: Number.isNaN(total) ? list.length : total,
            };
        }
        case SUCCESS(ACTION_TYPES.CREATE_CARD_FREEZE_REQUEST):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD_FREEZE_REQUEST):
        case SUCCESS(ACTION_TYPES.APPROVE_CARD_FREEZE_REQUEST):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                loading: false,
            };
        case ACTION_TYPES.RESET:
            return { ...initialState };
        default:
            return state;
    }
};
export const getEntities = (params) => ({
    type: ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_LIST,
    payload: cmsHttp().get(listApiUrl, params === undefined ? undefined : { params: buildSpringPageParams(params) }),
});
export const getEntitiesByCardId = (cardId, params) => ({
    type: ACTION_TYPES.FETCH_CARD_FREEZE_REQUESTS_BY_CARD_ID,
    payload: cmsHttp().get(`${apiUrl}/card/${cardId}`, params === undefined ? undefined : { params: buildSpringPageParams(params) }),
});
export const createEntity = (body) => async (dispatch) => dispatch({
    type: ACTION_TYPES.CREATE_CARD_FREEZE_REQUEST,
    payload: cmsHttp().post(apiUrl, body),
});
export const updateEntity = (body) => async (dispatch) => {
    if (body.id == null) {
        throw new Error('card freeze request id is required');
    }
    return dispatch({
        type: ACTION_TYPES.UPDATE_CARD_FREEZE_REQUEST,
        payload: cmsHttp().put(`${apiUrl}/${body.id}`, body),
    });
};
export const approveRequest = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.APPROVE_CARD_FREEZE_REQUEST,
    payload: cmsHttp().post(`${apiUrl}/${id}/approve`),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
